"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalPicker = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const react_lazy_load_1 = __importDefault(require("react-lazy-load"));
const horizontal_picker_styles_1 = require("./horizontal-picker.styles");
const HorizontalPicker = (_a) => {
    var { resetButtonTitle, searchPlaceHolder, activeTitle, height, data, selectedIds, onDataChange, onReset = () => { } } = _a, props = __rest(_a, ["resetButtonTitle", "searchPlaceHolder", "activeTitle", "height", "data", "selectedIds", "onDataChange", "onReset"]);
    const [searchInputValue, setSearchInputValue] = (0, react_1.useState)('');
    const [selectedItems, setSelectedItems] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        setSelectedItems(selectedIds || data.filter((item) => (item.disableRemove)).map((item) => (item.id)));
    }, []);
    (0, react_1.useEffect)(() => {
        if (selectedIds && !(0, ramda_1.equals)(selectedIds, selectedItems)) {
            setSelectedItems(selectedIds);
        }
    }, [selectedIds, selectedItems]);
    const resetSelections = () => {
        onReset();
    };
    const addItem = (item) => {
        const result = [...selectedItems, item.id];
        onDataChange(result);
        setSelectedItems(result);
    };
    const removeItem = (item) => {
        const result = [...selectedItems.filter((itemId) => itemId !== item.id)];
        onDataChange(result);
        setSelectedItems(result);
    };
    const filteredLeftData = (0, react_1.useMemo)(() => (data.filter((item) => {
        if (selectedItems.some((itemId) => itemId === item.id) || item.disableRemove) {
            return false;
        }
        if (item.label.toLowerCase().includes(searchInputValue.toLowerCase())) {
            return true;
        }
        return false;
    })), [data, selectedItems, searchInputValue]);
    const filteredRightData = (0, react_1.useMemo)(() => {
        const result = [];
        selectedItems.forEach((itemId) => {
            result.push(data.find((item) => item.id === itemId));
        });
        return result;
    }, [data, selectedItems, searchInputValue]);
    const renderDndItemCard = (0, react_1.useCallback)((item) => (react_1.default.createElement(horizontal_picker_styles_1.StyledDndCard, { "$default": item.disableRemove }, react_1.default.createElement(ui_components_1.Icon, { className: "HP-dnd-icon-drag", height: 16, width: 16, variant: "drag", color: ui_components_1.baseColors.disabled }), react_1.default.createElement("span", { className: "HP-dnd-title" }, item.label), react_1.default.createElement("span", { className: "HP-dnd-description" }, item.description || ''), !item.disableRemove && (react_1.default.createElement(ui_components_1.Icon, { className: "HP-dnd-icon-remove", height: "16px", width: "16px", color: ui_components_1.baseColors.red, variant: "minus", onClick: () => removeItem(item) })))), [removeItem, selectedItems]);
    const handleOrderChange = (newOrder) => {
        const result = newOrder.map((item) => item.id);
        onDataChange(result);
        setSelectedItems(result);
    };
    const LeftCard = ({ item }) => (react_1.default.createElement(horizontal_picker_styles_1.StyledLeftCard, null, react_1.default.createElement("span", { className: "HP-left-card-title" }, item.label), react_1.default.createElement(ui_components_1.Icon, { className: "HP-left-card-icon", color: ui_components_1.baseColors.primaryAccentGreen700, height: "16px", width: "16px", variant: "plus", onClick: () => addItem(item) })));
    const getLeftBlockOptions = () => {
        if (data.length < 400) {
            return filteredLeftData.map((item) => react_1.default.createElement(LeftCard, { key: item.id, item: item }));
        }
        return filteredLeftData.map((item) => (react_1.default.createElement(react_lazy_load_1.default, { key: item.id }, react_1.default.createElement(LeftCard, { item: item }))));
    };
    return (react_1.default.createElement(horizontal_picker_styles_1.StyledMain, Object.assign({ "$height": height }, props), react_1.default.createElement("div", { className: "HP-main-block" }, react_1.default.createElement(horizontal_picker_styles_1.StyledLeftBlock, null, react_1.default.createElement(ui_components_1.SearchInput, { className: "HP-left-block-search", placeholder: searchPlaceHolder, searchInputValue: searchInputValue, handleInputChange: (e) => setSearchInputValue(e.target.value), handleInputClear: () => setSearchInputValue('') }), react_1.default.createElement("div", { className: "HP-left-block-cards" }, getLeftBlockOptions())), react_1.default.createElement(horizontal_picker_styles_1.StyledRightBlock, null, react_1.default.createElement("div", { className: "HP-right-block-title" }, activeTitle), react_1.default.createElement("div", { className: "HP-right-block-content" }, react_1.default.createElement(ui_components_1.SimpleDragDropList, { uniqueId: "HorizontalPicker", data: filteredRightData, renderItem: renderDndItemCard, renderDropzone: () => react_1.default.createElement(horizontal_picker_styles_1.StyledDropZone, null), onOrderChange: handleOrderChange })))), react_1.default.createElement(ui_components_1.Button, { className: "HP-button-reset", title: resetButtonTitle, variant: "contained", onClick: resetSelections })));
};
exports.HorizontalPicker = HorizontalPicker;
